module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 99 && _vm.brandSelect.value !== '99' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group pull-right"
  }, [(_vm.$route.name !== 'storeInfo' &&
    _vm.storeSelect.value === 999999 && _vm.roleType !== 10) ? _c('span', [_c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                查看批次紀錄\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.brandSelect.value !== 99 && _vm.brandSelect.value !== '99' && _vm.storeSelect.value !== 999999) ? _c('span', [_c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                查看歷程紀錄\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(1)]) : (_vm.menuList.length === 0) ? _c('tbody', [_vm._m(2)]) : (_vm.menuList.length > 0) ? _c('tbody', _vm._l((_vm.menuList), function(menu, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(menu.name) + " (" + _vm._s(menu.id) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(menu.remark))]), _vm._v(" "), (_vm.storeSelect.value && _vm.storeSelect.value !== 999999) ? _c('td', [_c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id + '/' + _vm.storeSelect.value + '/forever'
      }
    }, [_c('button', {
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  永久停賣")])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id + '/' + _vm.storeSelect.value + '/daily'
      }
    }, [_c('button', {
      staticClass: "btn btn-success"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  當日停賣")])])], 1) : _c('td', [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#storesModal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCurrent(menu)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-home"
    })]), _vm._v(" \n                      "), _c('router-link', {
      attrs: {
        "to": '/disProduct/' + menu.brand_id + '/' + menu.id
      }
    }, [_c('button', {
      staticClass: "btn btn-danger"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": require("../../../assets/icon/ban.svg"),
        "alt": "point_icon"
      }
    }), _vm._v("  多店停賣")])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/reDisProduct/' + menu.brand_id + '/' + menu.id
      }
    }, [_c('button', {
      staticClass: "btn btn-success"
    }, [_c('img', {
      staticClass: "full-whdth",
      attrs: {
        "src": require("../../../assets/icon/relieveSus.svg"),
        "alt": "point_icon"
      }
    }), _vm._v("  多店解除停賣")])])], 1)])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('div', {
      staticClass: "inline-block",
      staticStyle: {
        "margin": "2.5px 5px 2.5px 0px"
      }
    }, [_c('label', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(store.name))])])
  }), 0)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("菜單 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9d16858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/DisItemTable.vue
// module id = 2561
// module chunks = 1